import { getCustomFormConfig } from '../../dateneingabe/co2_custom/getCustomFormConfig';
import { IDs } from '../../../helpers/IDs';
import * as React from 'react';

const ENTITIES: any = {
    [IDs.ENT_VSME_N1]: {
        id: 'n1', name: 'N1', titel: 'Strategie - Geschäftsmodell',
        fields : [
            { name: '(a) Gruppen angebotener Produkte bzw. Dienstleistungen', key: 'gruppen_produkte_dienstleistungen' },
            { name: '(b) Unternehmensmärkte', key: 'unternehmensmaerkte' },
            { name: '(c) Geschäftsbeziehungen', key: 'geschaeftsbeziehungen' },
            { name: '(d) Strategieelemente bzgl. Nachhaltigkeitsaspekte', key: 'strategieelemente_nachhaltigkeit' }
        ]
    },
    [IDs.ENT_VSME_N2]: {
        id: 'n2', name: 'N2', titel: 'Wesentliche Aspekte der Nachhaltigkeit',
        fields : [
            { name: '(a) Auswirkungen auf Menschen oder Umwelt', key: 'auswirkungen_menschen_umwelt' },
            { name: '(b) Auswirkungen auf derzeitige oder künftige Finanz- und Ertragslage', key: 'auswirkungen_finanz_ertragslage' },
            { name: '(c) Auswirkungen auf Tätigkeiten und Strategie', key: 'auswirkungen_taetigkeiten_strategie' }
        ]
    },
    [IDs.ENT_VSME_N3]: {
        id: 'n3', name: 'N3', titel: 'Management von Nachhaltigkeitsfragen',
        fields : [
            { name: 'Strategien', key: 'info_strategien' },
            { name: 'Maßnahmen', key: 'info_massnahmen' }
        ]
    },
    [IDs.ENT_VSME_N4]: {
        id: 'n4', name: 'N4', titel: 'Wichtige Interessensgruppen',
        fields : [
            { name: '(a) Kategorien der wichtigsten Beteiligten', key: 'beteiligungskategorien' },
            { name: '(b) Engagement-Aktivitäten', key: 'engagement_aktivitaeten' }
        ]
    },
    [IDs.ENT_VSME_N5]: {
        id: 'n5', name: 'N5', titel: 'Nachhaltige Unternehmensführung',
        fields : [
            { name: 'Zuständigkeitsverteilung bzgl. Nachhaltigkeit', key: 'nachhaltigkeitszustaendigkeiten' }
        ]
    }
};
let CACHE: any;
let DATA: any;
let DOC_TYPE: string;
let END: number;
let STANDORT: number;
let START: number;

export function getConfig(dataGlobal: any, jahrVon: number, jahrBis: number, standortTid: number, docType?: 'docx' | 'pdf'): any {
    CACHE = {};
    DATA = dataGlobal || {};
    DOC_TYPE = docType || null;
    END = jahrBis || 0;
    STANDORT = standortTid || 0;
    START = jahrVon || 0;
    const b1: any = (DATA[IDs.ENT_VSME_B1] || [])
        .find((item: any) => (item.standort_tid_orig || item.standort_tid) === STANDORT) || {};
    const hasModul: boolean = Object.keys(b1).length ? (b1.modul === 'basis_pat' || b1.modul === 'basis_pat_geschaeft') : true;

    if (!hasModul) {
        return {};
    }
    const configColumns: any = getConfigColumns() || {};
    const configEntities: any = /*getConfigEntities() || */{};

    return {
        custom_row_classes: [...(configColumns.classes || []), ...(configEntities.classes || [])],
        rows: [...(configColumns.rows || []), ...(configEntities.rows || [])]
    };
}

function getConfigColumns(): any {
    const config: any = {
        classes: [
            ['row_field_vsme_spacer', 'row_field_vsme_spacer'],
            ['row_field_vsme_heading2', 'row_field_vsme_heading_left'],
            ['row_field_vsme_sub_span', 'row_field_vsme_none']
        ],
        rows: [
            [, ],
            ['PAT-\nmodul', 'Berichtskriterium'],
            ['Die Informationen des PAT-Moduls beruhen auf qualitativen Angaben und werden nur im Bericht dargestellt.', '.']
        ]
    };

    for (let jahr: number = START; jahr <= END; ++jahr) {
        config.classes[0].push('row_field_vsme_spacer');
        config.classes[1].push('row_field_vsme_heading');
        config.classes[2].push('row_field_vsme_none');
        config.rows[0].push('.');
        config.rows[1].push(jahr);
        config.rows[2].push('.');
    }

    return config;
}

function getConfigEntities(): any {
    const config: any = { classes: [], rows: [] };

    Object.keys(ENTITIES).forEach((key: string) => {
        const entity: any = ENTITIES[key] || {};
        config.classes.push(['row_field_vsme_sub_left', 'row_field_vsme_sub_left']);
        config.rows.push([entity.name, entity.titel.toUpperCase()]);
        setConfigEntityColumns(key, config);
        setConfigEntityData(key, config);
    });

    return config;
}

function setConfigEntityColumns(entity: string, config: any): void {
    const column: string = (ENTITIES[entity] || {}).column || '';
    const index: number = config.rows.length - 1;

    for (let jahr: number = START; jahr <= END; ++jahr) {
        config.classes[index].push('row_field_vsme_sub');
        config.rows[index].push(column);
    }
}

function setConfigEntityData(key: string, config: any): void {
    ((ENTITIES[key] || {}).fields || []).forEach((item: any) => {
        setConfigEntityValues(config, item, key);
    });
}

function setConfigEntityValues(config: any, field: any, entity: string): void {
    const classes: string[] = field.classes || [];
    const id: string = field.entity || entity;
    const key: string = field.key || null;
    config.classes.push([classes[0] || 'row_field_vsme_left', classes[1] || 'row_field_vsme_left']);
    config.rows.push([]);
    const index: number = config.rows.length - 1;

    for (let jahr: number = START; jahr <= END; ++jahr) {
        const classes: string[] = field.classes || [];
        const items: any[] = [];

        (DATA[id] || []).forEach((item: any) => {
            if ((item.standort_tid_orig || item.standort_tid) === STANDORT && item.jahr === jahr) {
                items.push(transformItem(item, id, { jahr, standort_tid: STANDORT }));
            }
        });
        const item: any = items[0] || {};
        const value: any = item[key];

        if (!config.rows[index].length) {
            config.rows[index].push('');
            config.rows[index].push(field.name);
        }
        config.classes[index].push(classes[2] || 'row_field_vsme_left');
        config.rows[index].push(value);
    }
}

function transformItem(item: any, entity: string, filter: any): any {
    if (!item.tid) {
        return item;
    }

    if (!CACHE[entity]) {
        CACHE[entity] = {};
    }

    if (!CACHE[entity][item.tid]) {
        const status: any = getCustomFormConfig(entity, item, DATA, null, filter) || {};
        CACHE[entity][item.tid] = { ...item };

        Object.keys(status).forEach((key: string) => {
            if ((status[key].hidden || status[key].hidden_input) && ['jahr', 'standort_tid'].indexOf(key) === -1) {
                delete CACHE[entity][item.tid][key];
            }
        });
    }

    return CACHE[entity][item.tid];
}
